<template>
    <div class="container">
        <div class="banner">
            <img class="banner_img1" v-if="type === 1" src="../assets/image/home_banner3.png" alt="院校服务"/>
            <img class="banner_img2" v-if="type === 2" src="../assets/image/home_banner1.png" alt="企业服务"/>
            <img class="banner_img3" v-if="type === 3" src="../assets/image/home_banner2.png" alt="学生服务"/>
        </div>
        <div class="main">
            <!--服务优势--学校、企业、学生-->
            <div class="fwys width">
                <h1 class="font_30 t_c m_t4">服务优势</h1>
                <ul class="fwys_ul clearfix" v-if="type === 1">
                    <li :class="{active: (index === idx), 'f_l': true, 'm_r1': true}" v-for="(item, idx) in yxfwList"
                        :key="idx" @mouseenter="mouseenter(idx)" @mouseleave="mouseleave" style="width: 230px;height: 354px">
                        <div class="fwys_img1"
                             :style="{backgroundImage: 'url('+ item.img + ')', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat'}"></div>
                        <div class="fwys_title font_20 t_c m_b2">{{item.title}}</div>
                        <p class="font_16">{{item.content}}</p>
                    </li>
                </ul>
                <ul class="fwys_ul clearfix" v-if="type === 2">
                    <li :class="{active2: (index === idx), 'f_l': true, 'm_r1': true}" v-for="(item, idx) in qyfwList"
                        :key="idx" @mouseenter="mouseenter(idx)" @mouseleave="mouseleave">
                        <div class="fwys_img1"
                             :style="{backgroundImage: 'url('+ item.img + ')', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat'}"></div>
                        <div class="fwys_title font_18 t_c m_b2">{{item.title}}</div>
                        <p class="font_16">{{item.content}}</p>
                    </li>
                </ul>
                <ul class="fwys_ul clearfix" v-if="type === 3">
                    <li :class="{active3: (index === idx), 'f_l': true, 'm_r1': true}" v-for="(item, idx) in xsfwList"
                        :key="idx" @mouseenter="mouseenter(idx)" @mouseleave="mouseleave" style="width: 230px;height: 354px">
                        <div class="fwys_img1"
                             :style="{backgroundImage: 'url('+ item.img + ')', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat'}"></div>
                        <div class="fwys_title font_18 t_c m_b2">{{item.title}}</div>
                        <p class="font_16">{{item.content}}</p>
                    </li>
                </ul>
            </div>

            <!--首页介绍--学校-->
            <div class="syjs clearfix width" v-if="type === 1">
                <h1 class="font_30 t_c" style="margin-bottom: 80px">首页介绍</h1>
                <div class="syjs_l f_l">
                    <div class="syjs_l_item clearfix">
                        <div class="syjs_l_item1 f_l">
                            <div class="font_20 m_b1">合作园所</div>
                            <!-- <p class="font_16">全国已入驻上千家幼儿园，线上随时了解幼儿园的真实情况。</p> -->
                            <p class="font_16">全国已入驻上千家企业，线上随时了解企业真实情况；</p>
                        </div>
                        <div class="syjs_l_item_img gnjs_img1 m_l2 f_l"></div>
                    </div>
                    <div class="syjs_l_item clearfix">
                        <div class="syjs_l_item1 f_l">
                            <div class="font_20 m_b1">项目管理</div>
                            <p class="font_16">院校可以通过项目分批次管理实习就业生，方便查询往期就业生相关资料。</p>
                        </div>
                        <div class="syjs_l_item_img gnjs_img2 m_l2 f_l"></div>
                    </div>
                    <div class="syjs_l_item clearfix">
                        <div class="syjs_l_item1 f_l">
                            <div class="font_20 m_b1">我的学生</div>
                            <p class="font_16">根据就业分配，每位辅导教师可以通过手机APP在线管理自己负责的学生实习就业情况。</p>
                        </div>
                        <div class="syjs_l_item_img gnjs_img3 m_l2 f_l"></div>
                    </div>
                    <div class="syjs_l_item clearfix">
                        <div class="syjs_l_item1 f_l">
                            <div class="font_20 m_b1">安全签到</div>
                            <p class="font_16">通过学生每天的安全打卡信息，实时了解学生的安全情况。</p>
                        </div>
                        <div class="syjs_l_item_img gnjs_img4 m_l2 f_l"></div>
                    </div>
                    <div class="syjs_l_item clearfix">
                        <div class="syjs_l_item1 f_l">
                            <div class="font_20 m_b1">实习日志</div>
                            <p class="font_16">根据院校需求，实现学生线上提交实习日志，辅导教师可随时查看学生日志，并给予评价及实习指导和督促工作。</p>
                        </div>
                        <div class="syjs_l_item_img gnjs_img5 m_l2 f_l"></div>
                    </div>
                </div>
                <div class="syjs_img f_l"></div>
                <div class="syjs_r f_r">
                    <div class="syjs_l_item clearfix">
                        <div class="syjs_l_item_img gnjs_img6 m_r2 f_l"></div>
                        <div class="syjs_l_item1 f_l" style="width: 320px;">
                            <div class="font_20 m_b1">请假审批</div>
                            <p class="font_16">学生线上提交请假申请，同时发送至院校、企业管理人员，通过多方确认完成审批，以确保学生请假的真实性，并自动计入学生考勤。</p>
                        </div>
                    </div>
                    <div class="syjs_l_item clearfix">
                        <div class="syjs_l_item_img gnjs_img7 m_r2 f_l"></div>
                        <div class="syjs_l_item1 f_l" style="width: 320px;">
                            <div class="font_20 m_b1">问题处理</div>
                            <p class="font_16">学生在实习期间，遇到任何问题可线上反馈，由奕杰、院校、企业了解情况及时协调解决。</p>
                        </div>
                    </div>
                    <div class="syjs_l_item clearfix">
                        <div class="syjs_l_item_img gnjs_img8 m_r2 f_l"></div>
                        <div class="syjs_l_item1 f_l" style="width: 320px;">
                            <div class="font_20 m_b1">实习回访</div>
                            <p class="font_16">实习过程中，学校指导老师或者奕杰老师定期或者不定期到实习单位对学生进行回访，通过图片、文字描述线上记录回访情况。</p>
                        </div>
                    </div>
                    <div class="syjs_l_item clearfix">
                        <div class="syjs_l_item_img gnjs_img9 m_r2 f_l"></div>
                        <div class="syjs_l_item1 f_l" style="width: 320px;">
                            <div class="font_20 m_b1">校企互评</div>
                            <p class="font_16">学生对企业做出真实评价，给后期实习的学生提供了解该企业的更多依据；企业对学生的评价，将作为实习鉴定的重要考核依据。</p>
                        </div>
                    </div>
                    <div class="syjs_l_item clearfix">
                        <div class="syjs_l_item_img gnjs_img10 m_r2 f_l"></div>
                        <div class="syjs_l_item1 f_l" style="width: 320px;">
                            <div class="font_20 m_b1">通知</div>
                            <p class="font_16">院校可线上发布相关通知，让学生及时了解相关通知内容。</p>
                        </div>
                    </div>
                </div>
            </div>

            <!--首页介绍--企业-->
            <div class="gar_syjs_box" v-if="type === 2">
                <!-- <div class="gar_syjs"></div> -->
                <div class="syjs1">
                    <div class="gar_syjs_img">
                        <img src="../assets/image/qyfw_sy.png" alt="">
                    </div>
                    <div class="gar_syjs_r">
                        <!-- <h2 class="font_30 m_b4">奕杰阳光招聘服务平台</h2> -->
                        <p class="font_16 justify">构建可信赖的幼教招聘服务平台
                            <!-- <br> -->
                            奕杰阳光幼教管理中心经过多年与学校的校企合作、与幼儿园的师资招聘合作，总结各省市学前教育专业实习、就业的特点与特色，研发“奕杰平台”将多年经验与互联网大数据相结合。首创学前教育专业实习、就业线上实时对比分析，纵向本校历届学生实习、就业特色分析，横向同级别学校优劣势对比，更深层次将学校人才培养与企业人才需求紧密结合在一起。
                        </p>
                    </div>
                </div>
            </div>

            <!--首页介绍--学生-->
            <div class="stu_syjs_box" v-if="type === 3">
                <div class="stu_syjs">
                    <div class="syjs clearfix">
                        <h1 class="font_30 t_c m_b4">首页功能介绍</h1>
                        <div class="syjs_wrap">
							<div class="stu_syjs_l f_l" style="padding-top: 40px">
							    <!--       安全签到--评价-->
							    <div class="clearfix" style="padding-bottom: 10px">
							        <div class="syjs_l_item clearfix f_l">
							            <div class="syjs_l_item_img gnjs_img1 m_r2 f_l"></div>
							            <div class="syjs_l_item1 f_l">
							                <div class="font_20 m_b1 bold">安全签到</div>
							                <p class="font_16">
							                    每天通过APP安全打卡，让辅导老师实时了解你的安全情况。</p>
							           </div>
							        </div>
							        <div class="syjs_l_item clearfix f_r">
							            <div class="syjs_l_item_img gnjs_img2 m_r2 f_l"></div>
							            <div class="syjs_l_item1 f_l">
							                <div class="font_20 m_b1 bold">评价</div>
							                <p class="font_16">
							                    学生代表院校对企业做出真实评价，为后期实习的学生提供了解该企业的更多依据。</p>
							            </div>
							        </div>
							    </div>
							    <!--       问题处理    实习日志            -->
							    <div class="clearfix" style="padding-bottom: 10px">
							        <div class="syjs_l_item clearfix f_l">
							            <div class="syjs_l_item_img gnjs_img3 m_r2 f_l"></div>
							            <div class="syjs_l_item1 f_l">
							                <div class="font_20 m_b1 bold">问题处理</div>
							                <p class="font_16">
							                    学生在实习期间，遇到任何问题可线上反馈，由奕杰、院校、企业了解情况及时协调解决。</p>
							            </div>
							        </div>
							        <div class="syjs_l_item clearfix f_r">
							            <div class="syjs_l_item_img gnjs_img4 m_r2 f_l"></div>
							            <div class="syjs_l_item1 f_l">
							                <div class="font_20 m_b1 bold">实习日志</div>
							                <p class="font_16">
							                    学生线上提交实习日志，辅导教师可随时查看日志，并给予评价及实习指导和督促工作。</p>
							            </div>
							        </div>
							    </div>
							    <!--    请假审批--通知 -->
							    <div class="clearfix" style="padding-bottom: 10px">
							        <div class="syjs_l_item clearfix f_l">
							            <div class="syjs_l_item_img gnjs_img5 m_r2 f_l"></div>
							            <div class="syjs_l_item1 f_l">
							                <div class="font_20 m_b1 bold">请假审批</div>
							                <p class="font_16">
							                    学生线上提交请假申请，企业领导实时审批。</p>
							            </div>
							        </div>
							        <div class="syjs_l_item clearfix f_r">
							            <div class="syjs_l_item_img gnjs_img6 m_r2 f_l"></div>
							            <div class="syjs_l_item1 f_l">
							                <div class="font_20 m_b1 bold">通知</div>
							                <p class="font_16">
							                    通过APP线上发布通知，学生可及时了解相关通知内容。</p>
							            </div>
							        </div>
							    </div>
							    <!--考勤打卡 -- 离职申请-->
							    <div class="clearfix" style="padding-bottom: 10px">
							        <div class="syjs_l_item clearfix f_l">
							            <div class="syjs_l_item_img gnjs_img7 m_r2 f_l"></div>
							            <div class="syjs_l_item1 f_l">
							                <div class="font_20 m_b1 bold">考勤打卡</div>
							                <p class="font_16">
							                    学生线上提交考勤打卡，企业领导实时审批。</p>
							            </div>
							        </div>
							        <div class="syjs_l_item clearfix f_r">
							            <div class="syjs_l_item_img gnjs_img8 m_r2 f_l"></div>
							            <div class="syjs_l_item1 f_l">
							                <div class="font_20 m_b1 bold">离职申请</div>
							                <p class="font_16">
							                    学生线上提交离职申请，企业领导实时审批。</p>
							            </div>
							        </div>
							    </div>
							
							</div>
							<div class="stu_syjs_r f_r"></div>
						</div>
                    </div>
                </div>
            </div>

            <!--学生发展前景--学生-->
           <!-- <div class="hzlc width" v-if="type === 3">
                <h1 class="font_30 m_b4 t_c">实习生未来发展前景</h1>
                <ul class="hzlc_ul clearfix box_sizing">
                    <li class="hzlc_li f_l" v-for="(item, index) in hzlcList" :key="index">
                        <div class="hzlc_img m_b2"
                             :style="{backgroundImage: 'url(' + item.img + ')', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat'}"></div>
                        <h3 class="font_20 m_b2 t_c">{{item.title}}</h3>
                        <p class="font_16" v-if="item.con1">{{item.con1}}</p>
                        <p class="font_16" v-if="item.con2">{{item.con2}}</p>
                        <p class="font_16" v-if="item.con3">{{item.con3}}</p>
                    </li>
                </ul>
            </div>
 -->
            <!--企业招聘流程-->
            <div class="qyfw_zplc" v-if="type === 2">
                <div class="zplc1 width">
                    <h2 class="font_30 t_c">企业招聘流程</h2>
                    <div class="zplc_wrap">
                        <div class="zplc1_l black_color">
                            <div class="font_18 m_t2 m_b2 bold">
                                <img src="../assets/image/01.png" alt="01">
                                <span class="font_20 m_l2">下载APP</span>
                            </div>
                            <p class="font_16">扫描二维码，下载企业端APP</p>
                        </div>
                        <div class="zplc1_r">
                             <div class="androind_code">
                                <img class="m_b4" :src="Android_garden" alt="Android">
                                <p class="t_c font_16">Android下载</p>
                            </div>
                            <div class="ios_code">
                                <img class="m_b4" :src="ios_garden" alt="iOS">
                                <p class="t_c font_16">iOS下载</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="zplc2_con">
                    <div class="zplc2_box">
                        <div class="zplc2">
                            <div class="zplc2_r"></div>
							<div class="zplc2_l">
							    <div class="font_26 bold m_b2">
							        <img src="../assets/image/02.png" alt="02">
							        <span class="font_20 m_l2">点击招聘</span>
							    </div>
							    <p class="font_16 justify">在推荐页的项目中提招聘需求，等待学生投递简历</p>
							</div>
                        </div>
                    </div>
                </div>

                <div class="zplc3_box">
                    <div class="zplc3" style="display:flex;align-items:center;">
						<div class="zplc3_r">
						    <div class="font_26 bold m_b2">
						        <img src="../assets/image/03.png" alt="03">
						        <span class="font_20 m_l2">简历筛选确定</span>
						    </div>
						    <p class="font_16 justify">在招聘管理中查看发布的所有需求，在每个招聘需求下，查看简历信息、挑选简历并提交确认订单。</p>
						</div>
                        <div class="zplc3_img"></div>
                    </div>
                  <!--  <div class="font_20 t_c m_b4">简历接收说明</div>
                    <p class="font_16 justify" style="line-height: 24px">注：为了能快速让每个企业招到合适的人选，避免应聘者海量投递，增加企业HR的工作效率，我们设定每个项目需求下只能接收需求数*2的简历数；例如：需求2人，最多只能收到4份简历，遇到心仪的学生，企业需要尽快确认，如果没合适的，也请尽快放弃，才能再次收到其它应聘者的简历。</p> -->
                </div>

                <div class="stu_syjs_box" style="background-color: transparent;">
                    <div class="zplc4_box">
                        <div class="zplc4">
							<div class="zplc2_r"></div>
                            <div class="zplc2_l">
                                <div class="font_26 bold m_b2">
                                    <img src="../assets/image/04.png" alt="04">
                                    <span class="font_20 m_l2">等待实习生入职</span>
                                </div>
                                <p class="font_16 justify">企业在线上与实习生确定录用关系后，院校统一安排实习生到京时间，企业只需要在约定的时间等待实习生入职即可。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--关注的问题-->
        <div class="problem_img1 white_color" v-if="type === 1" style="height:auto">
            <div class="pro_width">
                <h2 class="font_36 t_c">我们共同关注的问题</h2>
                <div class="commonFollow" style="margin-top: 38px;">
                    <div class="commonFollow_item" v-for="item in commonFollow" :key="item.title">
                        <img :src="item.img" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="problem_img3 white_color" v-if="type === 3">
            <div class="pro_width">
                <h2 class="font_36 t_c">实习生到岗实习前期准备</h2>
                <div class="pro_lr_box clearfix">
                    <div class="pro_l f_l">
                        <div class="pro1">
                            <p class="font_26">1.自费部分</p>
                            <p class="font_18">a)首年体检费、工服押金；</p>
                            <p class="font_18">b)住宿水、电、网等平摊费用；</p>
                        </div>
                        <div class="pro3">
                            <p class="font_26">3.实习生要求</p>
                            <p class="font_18">a)遵守学校规定的实习期限；</p>
                            <!-- <p class="font_18">b)遵守园所的各项规章制度（包括寝室卫生、安全等）；</p> -->
							<p class="font_18">b)遵守企业的各项规章制度（包括寝室卫生、安全等）；</p>
                            <!-- <p class="font_18">c)如特殊情况需中止实习、需提前取得园所领导、学校的同意、否则未结算工资园所不予发放（实习期间擅自离职将不再推荐实习单位）；</p> -->
							<p class="font_18">c)如特殊情况需中止实习、需提前取得企业领导、学校的同意、否则未结算工资企业不予发放（实习期间擅自离职将不再推荐实习单位）；</p>
							<p class="font_18">d)勤学、勤问、积极学习、服从指导老师的工作安排；</p>
							<p class="font_18">e)严格遵守薪资保密；</p>
                        </div>
                    </div>
                    <div class="pro_r f_r">
						<div class="pro2" style="margin-top: 0;">
						    <p class="font_26">2.生活方面的准备</p>
						    <p class="font_18">a)1至2个月生活费；</p>
						    <p class="font_18">b)被褥及日常生活用品等；</p>
						</div>
                        <div class="pro2">
                            <p class="font_26">4.终止实习</p>
                            <p class="font_18">a)出现违法乱纪行为、如盗窃、打架、辱骂他人等立即终止实习；</p>
                            <!-- <p class="font_18">b)严禁打骂体罚或变相体罚幼儿、如有发生将立刻终止实习、并按照幼儿园规章制度进行处罚；</p> -->
                           <!-- <p class="font_18">b)无论工作时间还是节假日休息、如需外出办事或者游玩、至少要告知周围同事去向并保持联系方式畅通、如因个人原因与园所、学校、家人失联超过24小时、立即终止实习；</p> -->
						    <p class="font_18">b)无论工作时间还是节假日休息、如需外出办事或者游玩、至少要告知周围同事去向并保持联系方式畅通、如因个人原因与企业、学校、家人失联超过24小时、立即终止实习；</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ImgUrl } from "../api/common_api";

    export default {
        name: 'ProductService',
        data() {
            return {
                type: 0,    //用于区分是学校、企业、还是学生
                index: -1,
                yxfwList: [
                    {
                        img: require('@/assets/image/yxfw_xssx.png'),
                        title: '学生线上双选',
                        content: '学生通过手机APP线上了解企业的真实情况及用人需求，根据本人意愿投递简历，由企业查看并接收，实现双方线上确认，直接入职上岗。'
                    },
                    {
                        img: require("@/assets/image/yxfw_sxbx.png"),
                        title: '实习保险',
                        content: '学生到岗前，线上提供多种意外保险供选择，企业可以线上为学生购买意外险，或者由学校统一提供校方实习险，保险单号在学校、企业、学生移动端口均有显示。'
                    },
                    {
                        img: require('@/assets/image/yxfw_sxgl.png'),
                        title: '实习管理',
                        content: '实习期内学校对学生的实习进行线上监督管理，包括实习过程中学生的考勤、请假、位置签到、问题反馈、辅导员回访、企业评价及实习企业的变更情况追踪等。'
                    },
                    {
                        img: require('@/assets/image/yxfw_sxbg.png'),
                        title: '实习报告生成',
                        content: '结合学生实习期间的工作、学习情况，线上自动生成实习报告，减轻了学生与教师对实习报告的收集整理工作。'
                    },
                    {
                        img: require('@/assets/image/yxfw_sjfx.png'),
                        title: '数据分析',
                        content: '通过大数据，对实习生的实习就业方向及倾向城市等信息进行数据分析，为院校的课程设置、优化提供建议。'
                    },
                ],  //服务优势--学校
                qyfwList: [
                    {
                        img: require('@/assets/image/qyfw_xszp.png'),
                        title: '线上精准招聘',
                        // content: '专业线上幼教招聘软件，精准匹配，提高招聘、上岗进度。'
                        content: '专业线上招聘软件，精准匹配，提高招聘、上岗进度。'
                    },
                    {
                        img: require("@/assets/image/qyfw_apxt.png"),
                        title: '安排协调',
                        content: '实习生上岗前期，企业遇到问题或调整实习生，我们会专人在第一时间进行协调。'
                    },
                    {
                        img: require('@/assets/image/qyfw_zsfw.png'),
                        title: '知识服务',
                        // content: '软件中提供幼教类各项知识服务资源，供幼儿园教学使用。'
                        content: '软件中提供各项知识服务资源，供实习生实习使用。'
                    },
                    {
                        img: require('@/assets/image/qyfw_zf.png'),
                        title: '辅导员走访',
                        // content: '每月有辅导员走访实习生所在园所、考察学生工作状态。'
                        content: '每月有辅导员走访实习生所在企业、考察学生工作状态。'
                    },
                ],  //服务优势--企业
                xsfwList: [
                    {
                        img: require('@/assets/image/xsfw_xssx.png'),
                        title: '实习线上双选',
                        // content: '线上了解幼儿园的详细情况（如：地里位置、园所环境、住宿环境等）学生赴京之前可知晓就职于园所，快速入职。'
						content: '线上了解企业的详细情况（如：地里位置、园所环境、住宿环境等）学生赴京之前可知晓就职于企业，快速入职。'
                    },
                    {
                        img: require("@/assets/image/xsfw_apxt.png"),
                        title: '安排协调',
                        content: '工作过程中可直接进行线上问题反馈，奕杰辅导员第一时间帮助协调解决。'
                    },
                    {
                        img: require('@/assets/image/xsfw_jyjn.png'),
                        title: '提高就业技能',
                        content: '定期组织实习生进行深化培训学习，工作中学历提升及线上自考证书等。'
                    },
                    {
                        img: require('@/assets/image/xsfw_zf.png'),
                        title: '辅导员回访',
                        content: '定期走访学生工作的单位、近距离了解学生工作与生活现状，和学生们一起畅聊实习中的喜闻乐事，分享工作经验。'
                    },
                    {
                        img: require("@/assets/image/xsfw_sybz.png"),
                        title: '再就业推荐',
                        content: '通过实习期间的工作提升，期望继续留京或返回家乡发展的同学，可在线上选择再就业，系统将根据你的需求，为您推荐相符的企业以及合适岗位再就业。'
                    },
                ],  //服务优势--学生
                hzlcList: [
                    {
                        // img: '../assets/image/home_hzlc1.png',
                        img: require('@/assets/image/xsfw_hzlc1.png'),
                        title: "班主任",
                        con1: '从实习生提升成为一个班的核心工作者，只需要三步“踏实的工作态度、肯付出的努力和良好的个人状态。”',
                        con2: '',
                    },
                    {
                        img: require('../assets/image/home_hzlc2.png'),
                        title: "保教主任",
                        con1: '教学工作一直是幼儿园的重中之重、也是园里很重要的管理角色、每一位好的学前教育生都应力争这个的机会。',
                        con2: '',
                    },
                    {
                        img: require('../assets/image/home_hzlc3.png'),
                        title: "无限空间",
                        con1: '未来发展的方向就看你今天做了怎样的选择、只要有梦想、实现起来就只差行动了、你想要怎样的未来你做主。',
                        con2: '',
                    },
                ],  //发展前景--学生
                Android_garden: ImgUrl + 'Android_garden.png',
                ios_garden: ImgUrl + 'ios_garden.png',
                // 共同关注问题-列表
                commonFollow:[
                    {
                        name:'安全问题',
                        img: require('../assets/image/gtgz_1.png'),
                        con1:[
                            '1、我们为学生提供一份免费意外保险；',
                            '2、学生每天的线上位置签到及每月的考勤统计，确保我们了解学生 在企业情况；',
                            '3、学生对工作环境、住宿环境的实时分享，确保我们了解学生的工 作、生活情况；',
                            '4、学生入职、调换企业都由我们奕杰老师安排；',
                            '5、企业、学生反馈的问题，我们老师都及时反馈，必要时现场处理。',
                        ]
                    },
                    {
                        name:'待遇问题',
                        img: require('../assets/image/gtgz_2.png'),
                        con1:[
                            '1、学生工资由企业直接发放；',
                            '2、根据企业制度提供住宿及工作餐等福利，双休及法定节假日休息；',
                            ' 3、根据学生的实际工作情况，工资按照岗位进行调整。'
                        ]
                    },
                    {
                        name:'协议及合同问题',
                        img: require('../assets/image/gtgz_3.png'),
                        con1:[
                            '1、学校要求的实习三方协议由学校、企业、学生直接签署；',
                            '2、奕杰阳光与企业有招聘服务协议，与学校有实习推荐安全协议等（根据学校实际情况而定）；',
                            '3、学校要求的就业协议由学校、企业、学生直接签署；',
                            '4、学生毕业后根据企业、学生双方意愿签署劳动就业合同。'
                        ]
                    },
                    {
                          
                        name:'发展问题',
                        img: require('../assets/image/gtgz_4.png'),
                        con1:[
                            '1、一线城市前沿的工作经验能让同学们学到更先进、更全面的理论 知识，并且在快速的生活、工作节奏中更快的提高学生们的实践 能力和吃苦耐劳的精神；',
                            '2、在一线城市经济发展大环境下，企业发展的待遇会跨越式提升；',
                            '3、有一线城市企业2至3年的工作经验，可以将我们的学生培养成 家乡企业的骨干力量，甚至成为创业的基础。'
                        ]
                    }
                ]
            };
        },
        created() {
            this.type = Number(this.$route.query.type);
        },
        mounted() {

        },
        methods: {
            mouseenter(idx) {
                this.index = idx
            },
            mouseleave() {
                this.index = -1
            },
        },
    };
</script>

<style scoped lang="stylus">
    $black_color = #1e2629;
    $gray_color = #666666;
    $yellow_color = #f6ca3c;
    $cyan_color = #6dbfeb;
    $red_color = #f16765;
    // $green_color = #c7dc72;
    $green_color = #FFF6D8;
    $blue_color = #9dd5ed;
    .container {
        .banner {
            font-size 0
        }

        .fwys {
            > h1 {
                margin-bottom 100px
                margin-top 80px
            }

            .fwys_ul {
                margin-bottom 100px

                .active {
                    border-bottom 10px solid #E3A83B
                    transform translateY(-5px)
                    transition all 0.2s
                }

                .active2 {
                    // border-bottom 10px solid #40a4dd
					border-bottom 10px solid #E16564;
                    transform translateY(-5px)
                    transition all 0.2s
                }

                .active3 {
                    border-bottom 10px solid $yellow_color
                    transform translateY(-5px)
                    transition all 0.2s
                }

                li {
                    width 290px
                    height 322px
                    position relative
                    padding 100px 30px 30px
                    box-sizing border-box
                    box-shadow: 4px 6px 24px 0 rgba(8, 8, 11, 0.2);

                    .fwys_img1,
                    .fwys_img2,
                    .fwys_img3,
                    .fwys_img4 {
                        width 100px
                        height 100px
                        border-radius 50%
                        position absolute
                        top -50px
                        left 0
                        right 0
                        margin-left auto
                        margin-right auto
                    }

                    p {
                        color $gray_color
                        text-align justify
                        text-justify: distribute
                    }

                    &:last-child {
                        margin-right 0
                    }
                }
            }
        }
		
		.stu_syjs_box{
			// background: #F5C94B;
			// background:#FFF6D8;
			color #000000;
		}

        .stu_syjs_box,
        .gar_syjs_box {
            width: 100%
            overflow hidden
            padding-top 140px
            position relative
        }
        .gar_syjs_box {
            // padding-bottom 140px
        }

        .stu_syjs,
        .gar_syjs,
        .zplc4_box {
            width 100%
            height 790px
            position: relative;
        }

        .stu_syjs_box {
            padding-top 40px
            // background $yellow_color
        }

        .gar_syjs {
            background $cyan_color
        }

        .zplc4_box {
            // background $blue_color
			background-color #E2F5FF;
        }

        // .stu_syjs::before,
		// .zplc4_box::before
        .gar_syjs::before,
        .gar_syjs::after,
         {
            position: absolute
            content: ""
            z-index: -1
            width: 110%
            height: 790px
        }

        // .stu_syjs::before,
        // .zplc4_box::before {
        //     right: 0
        //     background $yellow_color
        //     transform: rotate(4deg)
        //     transform-origin: right top
        // }

        // .zplc4_box::before {
        //     background $blue_color
        // }

        // .gar_syjs::before {
        //     left: 0
        //     background $cyan_color
        //     transform: rotate(-4deg)
        //     transform-origin: left top
        // }

        .gar_syjs::after {
            right 0
            background $cyan_color
            transform: rotate(-4deg)
            transform-origin right bottom 
        }

        .syjs {
            margin-bottom 100px
			.syjs_wrap{
				display: flex;
				align-items center;
				justify-content center;
			}
            .syjs_l, .syjs_r {

                .syjs_l_item {
                    width 400px
                    height 140px

                    .syjs_l_item1 {
                        width 300px
                        margin-top 5px

                        div {
                            color $black_color
                        }

                        p {
                            color $gray_color
                            line-height 24px
                            text-align justify
                            text-justify: distribute
                        }
                    }

                    .syjs_l_item_img {
                        width 60px
                        height 60px
                        border-radius 50%
                        margin-top 10px
                    }

                    .gnjs_img1 {
                        background url("../assets/image/yxfw_hzys.png") center center no-repeat
                    }

                    .gnjs_img2 {
                        background url("../assets/image/yxfw_xmgl.png") center center no-repeat
                    }

                    .gnjs_img3 {
                        background url("../assets/image/yxfw_wdxs.png") center center no-repeat
                    }

                    .gnjs_img4 {
                        background url("../assets/image/yxfw_aqqd.png") center center no-repeat
                    }

                    .gnjs_img5 {
                        background url("../assets/image/yxfw_sxrz.png") center center no-repeat
                    }

                    .gnjs_img6 {
                        background url("../assets/image/yxfw_qjsp.png") center center no-repeat
                    }

                    .gnjs_img7 {
                        background url("../assets/image/yxfw_wtcl.png") center center no-repeat
                    }

                    .gnjs_img8 {
                        background url("../assets/image/yxfw_sxhf.png") center center no-repeat
                    }

                    .gnjs_img9 {
                        background url("../assets/image/yxfw_xqhp.png") center center no-repeat
                    }

                    .gnjs_img10 {
                        background url("../assets/image/yxfw_tz.png") center center no-repeat
                    }
                }
            }

            .syjs_img {
                width 400px
                height 700px
                background url("../assets/image/yxfw_sy.png") center center no-repeat
            }

            .stu_syjs_l {
                width 800px

                .syjs_l_item {
                    width 380px
                    height 140px

                    .syjs_l_item1 {
                        width 280px
                        margin-top 5px

                        div {
                            color $black_color
                        }

                        p {
                            color $gray_color
                            line-height 25px
                        }
                    }

                    .syjs_l_item_img {
                        width 60px
                        height 60px
                        border-radius 50%
                        margin-top 5px
                    }

                    .gnjs_img1 {
                        background url("../assets/image/yxfw_aqqd.png") center center no-repeat
                    }

                    .gnjs_img2 {
                        background url("../assets/image/yxfw_xqhp.png") center center no-repeat
                    }

                    .gnjs_img3 {
                        background url("../assets/image/yxfw_wtcl.png") center center no-repeat
                    }

                    .gnjs_img4 {
                        background url("../assets/image/yxfw_sxrz.png") center center no-repeat
                    }

                    .gnjs_img5 {
                        background url("../assets/image/yxfw_qjsp.png") center center no-repeat
                    }

                    .gnjs_img6 {
                        background url("../assets/image/yxfw_tz.png") center center no-repeat
                    }

                    .gnjs_img7 {
                        background url("../assets/image/xsfw_kqdk.png") center center no-repeat
                    }

                    .gnjs_img8 {
                        background url("../assets/image/xsfw_lzsq.png") center center no-repeat
                    }

                }
            }

            .stu_syjs_r {
                width 692px
                height 700px
                background url("../assets/image/xsfw_sy.png") center center no-repeat
                margin-right -100px
				position: relative;
				left: -10%;

                &:hover {
                    -webkit-transform: scale(1.01, 1.01);
                    transform: scale(1.01, 1.01);
                    transition: all 0.3s
                    cursor pointer
                }
            }
        }


        .syjs1 {
            width 100%
            box-sizing border-box
            // height 700px
            background: #FFF9F9;
            display flex
            flex-direction column
            align-items center
            // position absolute
            // top 0
            // left 0
            // right 0
            // bottom 0
            // margin auto

            .gar_syjs_img {
                width 1508px
                height 662px
                // background url("../assets/image/qyfw_sy.png") center center no-repeat
                // margin-right 100px
                img{
                    width 100%
                    height 100%
                }
            }

            .gar_syjs_r {
                // width 580px
                width 1098px
                margin-top 3%
                padding-bottom 56px
                p {
                    line-height 27px
                }
            }
        }

        .hzlc {
            > h1 {
                margin-top: 100px
            }

            .hzlc_ul {
                padding 0 30px

                .hzlc_li {
                    width 220px
                    height 426px
                    margin-right 240px

                    &:nth-of-type(3n) {
                        margin-right 0
                    }

                    .hzlc_img {
                        width 220px
                        height 188px
                        margin-left 18px

                        &:hover {
                            transform: rotate(-10deg);
                            -ms-transform: rotate(-10deg); /* IE 9 */
                            -webkit-transform: rotate(-10deg); /* Safari and Chrome */
                            transition all 0.2s cubic-bezier(.86, 0, .07, 1)
                        }
                    }

                    p {
                        color $gray_color
                        text-align justify
                        line-height 24px
                        margin-left 10px
                    }
                }
            }
        }

        .commonFollow{
            display flex
            align-items center
            flex-wrap wrap
            justify-content space-between
            .commonFollow_item{
                width 500px
                margin-bottom 40px
                // height 343px
            }
        }

        .problem_img1, .problem_img3 {
            width 100%
            height 644px
            .pro_width {
                width 1280px
                margin 0 auto
                h2 {
                    padding-top 27px
                }
                .pro_lr_box {
                    justify-content space-between
                    margin-top 60px
                    .pro_l, .pro_r {
                        width 46%
                        padding-left: 8px
                        box-sizing border-box
                    }
                    .pro_l, .pro_r {
                        .pro1 p, .pro2 p, .pro3 p {
                            line-height 36px
                        }
                        .pro2, .pro3 {
                            margin-top 38px
                        }
                    }
                }
            }
        }

        .problem_img1, .problem_img3 {
            background url("../assets/image/xsfw_bg.png") center center no-repeat
            background-size cover
        }

        .qyfw_zplc {

            .zplc1 {
                height 600px
                padding 100px 100px 80px
                box-sizing border-box
                h2 {
                    margin-bottom 100px
                }
				.zplc_wrap{
					width 100%
					display flex
					justify-content center
				}
                .zplc1_l {
                    img {
						width 78px;
						height 78px;
                        // width 59px
                        // height 68px
                    }
					margin-right: 200px;
                }
                .zplc1_r{
                    display flex
                    justify-content: center
                }
                .androind_code {
                    margin-right 160px
                    img {
                        width 200px
                        height 200px
                    }
                }

                .ios_code {

                    img {
                        width 200px
                        height 200px
                    }
                }
            }

            .zplc2_con {
                width: 100%
                overflow hidden
                padding-bottom 140px

                .zplc2_box {
                    width 100%
                    height 790px
                    position: relative;
                    background $green_color

                    .zplc2 {
                        padding 80px 80px 0 100px
                        box-sizing border-box
						display: flex;
						align-items: center;
						// justify-content: space-between;

                        .zplc2_l {
                            width 280px
                            // color #ffffff
                            margin-top 2%
                            img {
                               width 78px;
                               height 78px;
                            }
                        }
                        .zplc2_r {
                            // width 449px
                            // height 700px
							width 762px;
							height 687px;
                            background url("../assets/image/qyfw_zplc2.png") center center no-repeat
							margin-left: 5%;
							margin-right: 2%;
                        }
                    }
                }
                .zplc2_box::before {
                    position: absolute
                    content: ""
                    z-index: -1
                    width: 110%
                    // height: 790px
                    left 0
                    background $green_color
                    transform: rotate(4deg)
                    transform-origin left bottom
                }
            }

            .zplc3_box {
                height 800px
                padding 120px 0 90px
                box-sizing border-box
                .zplc3 {
                    margin-bottom 90px
					justify-content center;
                    .zplc3_img {
                        // width 695px
                        // height 381px
                        width 1011px
                        height 714px
                        background url("../assets/image/qyfw_zplc3.png") center center no-repeat
                    }
                    .zplc3_r {
                        width 280px
                        color #333333
                        // margin-top 12%
                        margin-top 2%
						margin-left: 2%;
						p{
							line-height 27px;
						}
                        img {
                           width 78px;
                           height 78px;
                        }
                    }
                }
            }

            .zplc4 {
				display: flex;
				align-items center;
                padding 100px 80px 0 100px
                box-sizing border-box

                .zplc2_l {
                    width 288px
                    // color #ffffff
                    margin-top 14%
					p{
						line-height 27px;
					}
                    img {
                        width 78px;
                        height 78px;
                    }
                }
                .zplc2_r {
                    width 536px
                    height 486px
                    background url("../assets/image/qyfw_zplc4.png") center center no-repeat
					margin-left: 5%;
					margin-right: 10%;
                }
            }

        }
    }
</style>
